import { TextFieldProps } from '@blueshift-ui/inputs';
import TextField from '@blueshift-ui/inputs/dist/components/text-field';
import { Control, Controller, useForm } from 'react-hook-form';

function AgeField({ control, ...textFieldProps }: { control: Control<any> } & TextFieldProps) {
  const { control: defaultControl } = useForm();

  return (
    <Controller
      control={control || defaultControl}
      name="age"
      render={({ field: { ref, ...field } }) => (
        <TextField
          fullWidth
          InputLabelProps={{ shrink: true }}
          label="Age"
          type="number"
          {...field}
          {...textFieldProps}
        />
      )}
    />
  );
}

export default AgeField;
